(() => {
  const init = () => {
    document.querySelectorAll('.jp-product').forEach(root => {
      if (root.dataset.jpReady) return;
      const source = root.querySelector('[data-jp-image-map]');
      const gallery = root.querySelector('media-gallery');
      if (!source || !gallery) return;
      root.dataset.jpReady = 'true';
      const specs = root.querySelector('.jp-specs');
      const toggle = specs?.querySelector('.jp-specs-toggle');
      const panel = specs?.querySelector('.jp-specs-panel');
      const mobileToggle = specs?.querySelector('.jp-specs-mobile-toggle');
      const content = specs?.querySelector('.jp-specs-content');
      if (toggle && panel && mobileToggle && content) {
        const mobile = matchMedia('(max-width: 1023px)');
        let desktopExpanded = false;
        let mobileExpanded = false;
        const refreshSpecs = () => {
          const expanded = mobile.matches || desktopExpanded;
          const contentExpanded = !mobile.matches || mobileExpanded;
          specs.dataset.expanded = String(expanded);
          specs.dataset.mobileExpanded = String(contentExpanded);
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.querySelector('span').textContent = expanded ? toggle.dataset.hide : toggle.dataset.show;
          panel.setAttribute('aria-hidden', String(!expanded));
          panel.inert = !expanded;
          mobileToggle.setAttribute('aria-expanded', String(contentExpanded));
          content.setAttribute('aria-hidden', String(!contentExpanded));
          content.inert = !contentExpanded;
        };
        refreshSpecs();
        toggle.hidden = false;
        toggle.addEventListener('click', () => { desktopExpanded = !desktopExpanded; refreshSpecs(); });
        mobileToggle.addEventListener('click', () => { mobileExpanded = !mobileExpanded; refreshSpecs(); });
        mobile.addEventListener('change', refreshSpecs);
      }
      const track = root.querySelector('.jp-related__track');
      const controls = root.querySelector('.jp-related__controls');
      if (track && controls) {
        const prev = controls.querySelector('[data-jp-related-prev]');
        const next = controls.querySelector('[data-jp-related-next]');
        const updateControls = () => {
          controls.hidden = track.scrollWidth <= track.clientWidth + 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const move = direction => {
          const card = track.querySelector('.jp-card');
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0) : track.clientWidth;
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        new ResizeObserver(updateControls).observe(track);
        updateControls();
      }
      const images = JSON.parse(source.textContent);
      let frame;
      const sync = () => {
        gallery.querySelectorAll('.product__media[data-media-type="image"]').forEach(item => {
          const data = images[item.dataset.mediaId];
          const img = item.querySelector('img');
          const zoom = item.querySelector('[is="media-lightbox-button"]');
          if (zoom) zoom.tabIndex = getComputedStyle(item).display !== 'none' ? 0 : -1;
          if (!data || !img) return;
          if (img.getAttribute('srcset') !== data.srcset) img.setAttribute('srcset', data.srcset);
          if (img.getAttribute('src') !== data.src) img.setAttribute('src', data.src);
          if (img.alt !== data.alt) img.alt = data.alt;
        });
        const first = Array.from(gallery.querySelectorAll('.product__media[data-media-type="image"]')).find(item => getComputedStyle(item).display !== 'none');
        const dimension = root.querySelector('[data-jp-dimension-image]');
        const data = first && images[first.dataset.mediaId];
        if (dimension && data && dimension.getAttribute('src') !== data.src) dimension.setAttribute('src', data.src);
      };
      const observer = new MutationObserver(() => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(sync);
      });
      observer.observe(gallery, { subtree:true, childList:true, attributes:true, attributeFilter:['data-media-id','src','srcset','style'] });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


